import React from 'react';

function GoogleTranslate({children}) {
  return <div id="google_translate_element" style={{display: 'none'}}></div>;
}

export default GoogleTranslate;
